module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"badge":"AI 사이즈 추천"}}')
  delete Component.options._Ctor
}
